import 'jquery-modal';
import URI from 'uri.js';
import { initSelectVariant } from './selectVariant';
import { closeSliderCart } from '../slider-cart';
import { getProductJson } from './helpers';
import { openOutOfStockUpsell } from '../out-of-stock-upsell';
import { preloadImages } from '../../core/images';
import { propagateWishlistStateToStickyAddToCart } from '../../components/wishlist';
import TabsAutomatic from '../../components/tabs';
import initSizeGuide from '../size-guide';
import PlusSizes from './plus-sizes';

let selected_variant_id = '';
const show_zoom_loading = false;
let is_mobile_move = false;

const openModal = (modal_type) => {
  closeSliderCart();
  $(modal_type).modal({
    fadeDuration: 250,
    fadeDelay: 0.80,
  });
};

export default () => {
  if (!$('.template-product').length) {
    return false;
  }

  new PlusSizes();
  initSelectVariant();

  if (document.querySelectorAll('.product-overview-v3 .product-extra-v3 [role=tablist]').length > 0) {
    new TabsAutomatic(document.querySelectorAll('.product-overview-v3 .product-extra-v3 [role=tablist]')[0]);
  }

  $(window).on('load', () => {
    const product = getProductJson();
    if (product.available === false) {
      openOutOfStockUpsell();
    }
  });

  $(document).on('click focus', '[data-modal="#size-guide-modal"]', (e) => {
    const $item = $(e.currentTarget);
    openModal($item.data('modal'));

    $($item.data('modal')).off($.modal.OPEN);
    $($item.data('modal')).on($.modal.OPEN, () => {
      // new TabsAutomatic(document.querySelectorAll('#size-guide-modal [role=tablist]')[0]);
      initSizeGuide();

      $('.blocker').addClass('blocker--size-guide-modal');

      // [ADA]
      $('#size-guide-modal .close-modal').prependTo('#size-guide-modal');
      $('#size-guide-modal .close-modal').attr('role', 'button');
      $('#size-guide-modal .close-modal').trigger('focus');
      $('#size-guide-modal .ada-descriptive-text').attr('tabindex', '0').addClass('visually-hidden');
    });

    $($item.data('modal')).off($.modal.CLOSE);
    $($item.data('modal')).on($.modal.CLOSE, () => {
      $('.blocker').removeClass('blocker--size-guide-modal');

      // [ADA] We don't want to get the focus back at the beginning of the page
      $('[data-product-option-size]').first().trigger('focus');
    });
  });

  $(document).on('click touchend focus', '[data-modal="#size-unavailable-modal"]', (e) => {
    const $item = $(e.currentTarget);
    openModal($item.data('modal'));

    // Save the original variant id
    $($item.data('modal')).off($.modal.OPEN);
    $($item.data('modal')).on($.modal.OPEN, () => {
      const params = URI(window.location.href);
      selected_variant_id = params.query.variant;
      $('[data-size-oos]').removeClass('active');

      // [ADA]
      $('#size-unavailable-modal .close').prependTo('#size-guide-modal');
      $('#size-unavailable-modal .close').attr('role', 'button');
      $('#size-unavailable-modal .close').trigger('focus');
    });

    // Restore the original variant id
    $($item.data('modal')).off($.modal.CLOSE);
    $($item.data('modal')).on($.modal.CLOSE, () => {
      let newUrl = `${window.location.protocol}//${window.location.host}${window.location.pathname}`;
      if (typeof selected_variant_id !== 'undefined') {
        newUrl += `?variant=${selected_variant_id}`;
      }

      window.history.replaceState({ path: newUrl }, '', newUrl);

      $('[data-out-of-stock]').addClass('non-init');

      $('.product-extra-v3').trigger('focus');
    });
  });

  $(document).on('touchmove', '[data-product-main]', () => {
    is_mobile_move = true;
  });

  $(document).on('click focus', '[data-modal="#zoom-modal"]', (e) => {
    if (window.theme.breakpoints.current === 'mobile' && is_mobile_move) {
      is_mobile_move = false;
      return;
    }

    // [ADA]
    $('#zoom-modal .close').prependTo('#size-guide-modal');
    $('#zoom-modal .close').attr('role', 'button');
    $('#zoom-modal .close').trigger('focus');

    const $item = $(e.currentTarget);
    openModal($item.data('modal'));
    const zoom_image = $item.data('zoom');
    const zoom_image_alt = $item.attr('alt');
    const zoom_image_tmp = $item.attr('src');

    $($item.data('modal')).off($.modal.OPEN);
    $($item.data('modal')).on($.modal.OPEN, () => {
      if (show_zoom_loading) {
        $('[data-product-zoom-modal]').html(`
          <img loading="lazy" src="${zoom_image_tmp}" width="100" alt="${zoom_image_alt}" class="product-zoom__preload" />
          <div class="product-zoom__loader">
            <img loading="lazy" src="${$('[data-product-zoom-modal]').data('loader')}" width="100" alt="Loading..." />
            <p>Loading HD image...</p>
          </div>
        `);
      } else {
        $('[data-product-zoom-modal]').html(`
          <img loading="lazy" src="${zoom_image_tmp}" width="100" alt="${zoom_image_alt}" class="product-zoom__preload" />
        `);
      }

      preloadImages([zoom_image], () => {
        console.log('Zoom image loaded');
        const regex = /data-product-thumb/gi;

        $('[data-product-zoom-modal]').html(`
          <div class="zoom-content">
            <div class="zoom-content__thumbs" data-zoom-thumbs>
              ${($('[data-product-overview] [data-product-thumbs]')[0].outerHTML).replaceAll(regex, 'data-product-zoom-thumb')}
            </div>

            <div class="zoom-content__full" data-zoom-full>
              <img src="${zoom_image}" alt="Zoomed image - ${zoom_image_alt}" width="100%" onClick="javacsript:$('.close-modal').trigger('click');" class="product-zoom__image" />
            </div>
          </div>
        `);

        // $('html, body').animate({ scrollTop: 0 }, 'slow');
      });

      $('html').css('overflow', 'hidden');
    });

    $($item.data('modal')).off($.modal.CLOSE);
    $($item.data('modal')).on($.modal.CLOSE, () => {
      $('[data-product-zoom-modal]').empty();
      $('html').css('overflow', 'auto');
      $('[data-product-details] h1').trigger('focus');
    });
  });

  $(document).on('click touchend focus', '[data-buy-now]', (e) => {
    e.preventDefault();
    e.stopPropagation();
    const $item = $(e.currentTarget);

    if ($item.prop('disabled')) {
      return;
    }

    // https://community.shopify.com/c/shopify-design/cart-use-permalinks-to-pre-load-the-cart/td-p/613702#adding-a-buy-this-link-to-a-blog-post
    // http://yourstore.com/cart/#{variant_id}:#{quantity}(,...)
    const params = URI(window.location.href);
    selected_variant_id = params.query.variant;
    window.location.href = `${window.Shopify.routes.root}cart/${selected_variant_id}:1`;
  });

  // Click the wishlist icon from the product overview
  $(document).on('click touchend', '[data-product-overview] [data-wishlist-clickable]', (e) => {
    console.log('[wishlist] clicked');
    const $item = $(e.currentTarget);

    if (typeof $item.data('open-signin-actions-modal') !== 'undefined') {
      return;
    }
    
    $item.parent().find('.swym-button').trigger('click');

    propagateWishlistStateToStickyAddToCart();
  });

  // [ADA]
  $(document).on('keypress', '[data-product-overview] [data-wishlist-clickable]', (e) => {
    if (typeof $item.data('open-signin-actions-modal') !== 'undefined') {
      return;
    }

    const key = e.which;

    // Enter / spacebar
    if (key === 13 || key === 32) {
      const $item = $(e.currentTarget);
      $item.trigger('click');
    }
  });

  // Selected from the sticky add to cart
  $(document).on('click touchend', '[data-product-details-wishlist]', () => {
    $('[data-product-overview] [data-wishlist-clickable]').trigger('click');
  });

  // [ADA]
  $(document).on('keypress', '[data-product-details-wishlist]', (e) => {
    const key = e.which;

    // Enter / spacebar
    if (key === 13 || key === 32) {
      const $item = $(e.currentTarget);
      $item.trigger('click');
    }
  });

  window.setTimeout(() => {
    if (!$('[data-instagram] .fs-entry-container').length) {
      $('.product-instagram').addClass('inactive');
    }

    propagateWishlistStateToStickyAddToCart(true);
  }, 2000);

  $(document).on('click touchend', '[data-product-thumb]', (e) => {
    const $item = $(e.currentTarget);

    $('[data-product-main]').html(`<img class="product-main__image" src="${$item.data('product-full-url')}" data-zoom="${$item.data('product-zoom-url')}" data-modal="#zoom-modal" alt="${$item.find('img').attr('alt').replace('Thumbnail', 'Image')}" tabindex="-1">`);
  });

  $(document).on('click touchend', '[data-product-zoom-thumb]', (e) => {
    const $item = $(e.currentTarget);

    $('[data-zoom-full]').html(`<img src="${$item.data('product-zoom-url')}" alt="Zoomed image" width="100%" onclick="javacsript:$('.close-modal').trigger('click');" class="product-zoom__image" tabindex="-1">`);
  });

  return true;
};
